<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: student.full_name,
                        href: meta.links.student_show,
                    },
                    {
                        name: $tc('messages.grades_report', 2),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.students"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.trimester') }}</span>
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.comment') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(comment, index) in comments"
                                :key="comment.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div>{{ $t('messages.trimester') }} {{ comment.trimester }}</div>
                                    <div>
                                        {{ comment.date }}
                                    </div>
                                    <div>
                                        <AppButton
                                            class="mt-1"
                                            :href="comment.links.grades_report_show"
                                            target="_blank"
                                        >
                                            <svg viewBox="0 0 20 20" fill="currentColor" class="-ml-0.5 mr-2 w-4 h-4">
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
                                                    clip-rule="evenodd"
                                                ></path>
                                            </svg>
                                            {{ $t('messages.grades_report') }}
                                        </AppButton>
                                    </div>
                                    <div class="mt-1 flex gap-x-2 max-w-xs whitespace-normal">
                                        <span>
                                            <IconAlertTriangle
                                                class="h-6 w-6"
                                                :class="comment.is_visible ? 'text-yellow-400' : 'text-gray-300'"
                                            />
                                        </span>
                                        <p class="text-xs">{{ comment.explanation }}</p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-pre-line">
                                    <p v-html="comment.comment" />
                                </td>
                                <td class="px-6 py-4 text-sm leading-5 text-gray-500 flex justify-end space-x-1">
                                    <InertiaSquareLinkButton action="edit" :href="comment.links.edit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import AppButton from '@/components/AppButton.vue';
import { IconAlertTriangle } from '@tabler/icons-vue';

export default {
    components: {
        PanelPage,
        InertiaSquareLinkButton,
        ActivityMenuOptions,
        AppButton,
        IconAlertTriangle,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'comments', 'filters', 'student', 'group'],
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
